// Demo data configuration for PortfolioFeatureDemo component
// Update these values to change the demo content

export const DEMO_ABOUT_TEXT = "Retired U.S. Army Aviation Officer (Major) with over two decades of leadership in mission-critical operations and program management. My core strength lies in applying systems thinking, agile methodologies, and data analysis to enhance performance, eliminate inefficiencies, and guide organizations toward achieving their strategic goals.";

export const DEMO_SUBTITLE = "DIRECTOR OF AVIATION AND GROUND MAINTENANCE MANAGEMENT";

export const DEMO_FOOTER_TEXT = "DIRECTOR OF AVIATION AND GROUND MAINTENANCE MANAGEMENT";

export const DEMO_EXAMPLE_FILE = {
  id: 'example-1',
  name: "MRD's DC-S Touch Point Slides (3 May 23).pptx",
  category: 'powerpoint',
  size: 2458624, // ~2.4 MB
  summary: `This PowerPoint presentation showcases comprehensive aviation and ground maintenance management capabilities. The presentation demonstrates strategic leadership in DC-S (Data Center Services) touch point management, highlighting operational excellence, maintenance protocols, and system optimization strategies. Key topics covered include maintenance scheduling, quality assurance processes, safety compliance, and efficiency improvements in aviation ground operations. This document exemplifies professional presentation skills and technical expertise in aviation maintenance management.`,
  uploadedAt: new Date('2023-05-03').toISOString(),
  url: '/example-portfolio.pptx'
};
